//请自行添加语言资源
const yardLoadEfficiency = {

  itrYardCode:'堆场代码',
  itrYardName:'堆场名称',
  itrCode: 'ITR',
  totalQty: '总数量',
  customerCode: '租赁方编码',
  consigneeCode:'收货方编码',
  carrierNo:'承运商',
  shipGoodsFlagStr:'是否自提',

  truckNo:'车牌号',
  planExpToTime:'物流预约时间',
  inTime: '入库时间',
  outTime:'出库时间',
  loadUseHour:'装车用时',
  yardFinishDate:  '堆场完成时间',
  inImgCount: '入库拍照',
  outImgCount: '出库拍照',
  orderTypeCodeName: '类型',
  customerShortName: '客户名称',
  msg:{

  }
};
export default yardLoadEfficiency



// WEBPACK FOOTER //
// ./src/page/report/yardLoadEfficiency/lang/yardLoadEfficiency.zh.js